import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { RestorationProjectsProvider as Provider } from '../../components/context/restoration-projects.context';
import { sortBy } from 'lodash';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const RESTORATION_PROJECTS_QUERY = graphql`
query NodeAllRestorationProjectsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "RestorationProjects" } }) {
    nodes {
      data
    }
  }
}
`;

export const RestorationProjectsProvider: React.FC<any> = ({ children }) => {
  return (
    <Provider value={sortBy(shapeableProviderValue(useStaticQuery(RESTORATION_PROJECTS_QUERY), 'items'), 'name')}>
      {children}
    </Provider>
  );
};
